<template>
  <el-card style="margin: 4px;" v-loading="!tempSettings" shadow="hover">
    <div slot="header" class="clearfix top">
      <div class="flex topBar">
        <span class="mgra">Organization Settings</span>
      </div>
    </div>
    <el-form v-if="tempSettings">
        <el-form-item label="Organization Name">
          <el-input v-model="tempSettings.find((e) => e.name == 'OrgName').val" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="E-Mail">
          <el-input v-model="tempSettings.find((e) => e.name == 'OrgEmail').val" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="saveSettings">Save</el-button>
        </el-form-item>
    </el-form>
  </el-card>
</template>

<style scoped>
.topBar {
  align-items: center;
}
.button {
  margin: 4px;
  margin-right: 8px;
  margin-bottom: 0px;
  padding: 8px;
  padding-bottom: 0px;
  float: right;
}
.bottom {
  line-height: 12px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>

<script>
export default {
    data() {
        return {
            tempSettings: null,
            settings: null,
            rules: {
                OrgName: [
                    {required: true, message: "Please input name", trigger: "blur"}
                ],
                OrgEmail: [
                    {type: "number", message: "Term must be a number."},
                    {required: true, message: "Please input term", trigger: "blur"}
                ]
            }
        };
    },
    watch: {
        settings(val) {
            this.tempSettings = JSON.parse(JSON.stringify(val));
        }
    },
    mounted() {
        this.getSettings();
    },
    methods: {
        getSettings() {
            this.axios
                .get('/api/v1/settings/org', {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.settings = response.data;
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.message,
                        type: "error"
                    });
                });
        },
        saveSettings() {
            this.axios
                .put("/api/v1/settings/org", this.tempSettings, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.settings = response.data;
                    this.$message({
                        showClose: true,
                        message: "Settings saved successfuly",
                        type: "success"
                    });
                })
                .catch((err) => {
                    this.$message({
                        showClose: true,
                        message: err.response.data.message,
                        type: "error"
                    });
                });
        }
    }
}
</script>
